<template>
    <vue-countdown
        :time="expiryDelta"
    >
        <template
            slot-scope="props"
        >
            {{ f(props.totalHours) }}:{{ f(props.minutes) }}:{{ f(props.seconds) }}
        </template>
    </vue-countdown>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';

export default {
    name: "ExpiryCountdown",
    components: {VueCountdown},
    props: {
        booking: {
            type: Object,
            required: true
        }
    },
    computed: {
        bookingDate(){
            let bookingDate = new Date(this.booking.createdAt);
            bookingDate.setDate(bookingDate.getDate()+1);
            bookingDate.setHours(2);
            bookingDate.setMinutes(30);
            return bookingDate;
        },
        expiryDelta() {
            let now = new Date();
            let delta =  (
                this.bookingDate.getTime() + (168 * 60 * 60 * 1000)
            ) - now.getTime(); //168 Hours

            if(delta < 0) {
                delta = 0;
            }

            return delta;
        }
    },
    methods: {
        f(num){
            return String(num).padStart(2,'0');
        }
    }
}
</script>

<style scoped>

</style>
